<template>
  <div class="addaddresContainer">
    <md-field>
      <md-input-item title="國家/區域" readonly v-model="par.countryName">
      </md-input-item>
      <md-input-item title="姓名" placeholder="請輸入收貨人姓名" v-model="par.name">
      </md-input-item>
      <md-input-item title="聯繫電話" placeholder="請輸入收貨人電話" v-model="par.mobile">
      </md-input-item>
      <md-cell-item title="都市/區縣" @click="showPicker" v-if="par.code != 'SG' && par.code != 'MY'">
        <div slot="right">
          <span>{{ par.allname }}</span>
          <img src="@/assets/image/icon_dropdown.png" alt="" />
        </div>
      </md-cell-item>
      <md-input-item title="地區" placeholder="請輸入收貨人地區" v-model="par.areaName" v-if="
        par.code != 'TW' &&
        !par.areaId &&
        par.code != 'MY' &&
        par.code != 'SG'
      ">
      </md-input-item>
      <md-input-item title="地址1" v-if="par.code != 'MY' && par.code != 'SG'" placeholder="請輸入收貨人地址1"
        v-model="par.address">
      </md-input-item>
      <md-input-item v-if="par.code === 'SG' || par.code === 'MY'" title="地址" placeholder="請輸入收貨人地址"
        v-model="par.address">
      </md-input-item>
<!--      <md-input-item title="地址2" placeholder="請輸入收貨人地址2" class="none" v-model="par.addressStandby"-->
<!--        v-if="par.code != 'NZ' && par.code != 'SG' && par.code != 'MY' && par.code != 'KR'">-->
<!--      </md-input-item>-->

      <md-input-item title="郵遞區號" placeholder="請輸入收貨人郵遞區號" v-model="par.postalCode" maxlength="15">
      </md-input-item>
      <!--      <md-input-item-->
      <!--        class="heighter"-->
      <!--        title="英文地址"-->
      <!--        placeholder="完整的英文收件地址"-->
      <!--        v-model="par.addressStandby"-->
      <!--        v-if="par.code=='JP'">-->
      <!--        <span slot="right" style="color: #097ef7" @click="isSel=true">查看填寫範例</span>-->
      <!--      </md-input-item>-->
      <md-input-item :title="par.idTname" placeholder="請輸入收貨人證件號碼" v-model="par.identity"
        brief="該證件號用於當地實名認證，我們會嚴格保密該資訊" v-if="par.code == 'TW'" class="tanenr">
        <img src="@/assets/image/icon_dropdown.png" alt="" slot="right" style="width: 0.6rem"
          @click="isSelectorShow = true" />
      </md-input-item>
      <md-input-item title="通关码" placeholder="请输入韩国通关码" v-model="par.identity"
        brief="证件号用于当地通关，请如实填写，我们会严格保密该信息。收件姓名要跟申请通关码时或证件上的保持一致。" v-if="par.code == 'KR'">

      </md-input-item>
      <div v-if="par.code == 'KR'"  style="font-size: 0.24rem;text-align: left;color: #e51c23">
      <span  >注：使用登陆证号或护照号会产生简易费。</span>
      </div>
      <md-cell-item title="設為默認收貨地址" class="addresright" no-border>
        <md-switch slot="right" v-model="par.isdedfault" @change="handler('switch0', par.isdedfault, $event)" />
      </md-cell-item>
    </md-field>
    <md-tab-picker title="請選擇" describe="請選擇您所在的收貨人郵遞區號" large-radius :data="data" v-model="show" ref="tabpicker"
      :mask-closable="false" @select="select" @change="handleChange" />
    <md-selector v-model="isSelectorShow" default-value="2" :data="listtype" max-height="320px" title="證件類型"
      large-radius @choose="onSelectorChoose"></md-selector>
    <md-dialog title="實名認證提示" :closable="true" v-model="basicDialog.open" :btns="basicDialog.btns">
      {{ mserg }}
    </md-dialog>
    <md-dialog class="oebhe" :closable="true" v-model="isSel">
      <img src="@/assets/image/show.jpg" style="width: 100%; height: auto" />
    </md-dialog>
    <md-button type="warning" @click="submitpar">
      <md-activity-indicator v-if="loading" class="md-activity-indicator-css" type="carousel" :size="15" color="#fff"
        text-color="#fff"></md-activity-indicator>
      <span v-else>提交</span>
    </md-button>
  </div>
</template>

<script>
import {
  Button,
  InputItem,
  CellItem,
  Field,
  TabPicker,
  Toast,
  Selector,
  Switch,
  Dialog,
  ActivityIndicator,
} from "mand-mobile";

export default {
  name: "addAddres",
  components: {
    [TabPicker.name]: TabPicker,
    [Button.name]: Button,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Selector.name]: Selector,
    [Switch.name]: Switch,
    [Dialog.name]: Dialog,
    [ActivityIndicator.name]: ActivityIndicator,
  },
  data() {
    return {
      isfrsh: false,
      show: false,
      data: {},
      isSel: false,
      listtype: [
        {
          value: 0,
          text: "身份證",
        },
        {
          value: 1,
          text: "護照",
        },
      ],
      basicDialog: {
        open: false,
        btns: [
          {
            text: "查看教程",
            handler: this.onBasicCancel,
          },
          {
            text: "我知道了",
            handler: this.onBasicConfirm,
          },
        ],
      },
      mserg: "",
      msgid: "",
      ieminde: 0,
      loading: false,
      isSelectorShow: false,
      par: {
        countryName: "",
        name: "",
        countryId: 0,
        mobile: "",
        allname: "請選擇收貨人都市/區縣",
        address: "",
        addressStandby: "",
        postalCode: "",
        identity: "",
        areaName: "",
        areaId: "",
        code: "",
        isdedfault: false,
        isDefault: 0,
        idType: 0,
        idTname: "身份證",
        provinceId: "",
        cityId: "",
        cityName: "",
        provinceName: "",
        id: "",
      },
    };
  },
  activated() {
    if (this.isfrsh) {
      this.isfrsh = false;
      return;
    }
    document.title = this.$route.query.name;
    if (this.$route.query.id !== undefined) {
      Toast.loading("請稍等...");
      this.getaddresitem(this.$route.query.id);
    } else {
      this.district(JSON.parse(localStorage.getItem("userinfoMobie")).disVo.id);
      this.repert();
    }
  },
  methods: {
    getaddresitem(id) {
      const par = {
        id: id,
      };
      this.http
        .APIASK(this.ports.addressthe, "get", par)
        .then((res) => {
          this.par.name = res.name;
          this.par.mobile = res.mobile;
          this.par.address = res.address;
          this.par.id = res.id;
          this.par.addressStandby = res.addressStandby;

          this.par.idType = res.idType;
          this.par.isDefault = res.isDefault;
          this.par.identity = res.identity.replace(/\s+/g, '')  ;
          this.par.isDefault == 0
            ? (this.par.isdedfault = false)
            : (this.par.isdedfault = true);
          this.par.idType == 0
            ? (this.par.idTname = "身份證")
            : (this.par.idTname = "護照");
          this.getcountry(res);
          this.district(res.countryId);
          console.log(res);
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    getcountry(re) {
      const par = {
        parentId: 0,
      };
      this.http
        .APIASK(this.ports.country, "get", par)
        .then((res) => {
          var vnum = res.find((value) => value.id == re.countryId);
          this.par.countryName = vnum.name;
          this.par.countryId = vnum.id;
          this.par.code = vnum.code;
          this.par.postalCode = re.postalCode;
          if (this.par.code != "TW") {
            this.par.provinceId = re.provinceId;
            this.par.cityId = re.cityId;
            this.par.provinceName = re.provinceName;
            this.par.cityName = re.cityName;
            this.par.areaName = re.areaName;
            re.areaId ? (this.par.areaId = re.areaId) : (this.par.areaId = "");
            this.par.areaId
              ? (this.par.allname =
                this.par.provinceName + this.par.cityName + this.par.areaName)
              : (this.par.allname = this.par.provinceName + this.par.cityName);
          } else {
            (this.par.provinceId = re.cityId), (this.par.cityId = re.cityId);
            (this.par.provinceName = re.cityName),
              (this.par.cityName = re.cityName);
            this.par.areaName = re.areaName;
            re.areaId ? (this.par.areaId = re.areaId) : (this.par.areaId = "");
            this.par.areaId
              ? (this.par.allname = this.par.cityName + this.par.areaName)
              : (this.par.allname = this.par.cityName);
          }

          console.log(this.par);
          Toast.hide();
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    onBasicCancel() {
      this.isfrsh = true;
      this.loading = false;
      this.basicDialog.open = false;
      window.location.href =
        "/res/appservice/m/article/index.html?id=" + this.msgid + "&type=1";
    },
    onBasicConfirm() {
      this.loading = false;
      this.basicDialog.open = false;
    },
    onSelectorChoose({ value, text }) {
      this.par.idType = value;
      this.par.idTname = text;
    },
    district(id) {
      const par = {
        parentId: id,
        name: "",
      };
      this.http.APIASK(this.ports.districtsearch, "get", par).then((res) => {
        const result = res.map(function (item) {
          // tslint:disable-next-line:radix
          return {
            label: item.name,
            value: item.id,
            children: { name: "block", label: "请选择", options: [] },
          };
        });
        this.data = {
          name: "province",
          label: "请选择",
          options: result,
        };
        this.pushitmelist(res[0].id, 0);
      });
    },
    pushitmelist(id, index) {
      const par = {
        parentId: id,
        name: "",
      };
      this.http
        .APIASK(this.ports.districtsearch, "get", par)
        .then((res) => {
          const result = res.map(function (item) {
            // tslint:disable-next-line:radix
            return {
              label: item.name,
              value: item.id,
              children: { name: "are", label: "请选择", options: [] },
            };
          });
          this.data.options[index].children.options = result;
          console.log(this.data);
          Toast.hide();
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    showPicker() {
      this.show = true;
    },

    getallvalue(options) {
      this.par.provinceName = options[0].label;
      this.par.provinceId = options[0].value;
      this.par.cityName = options[1].label;
      this.par.cityId = options[1].value;
      if (options.length > 2) {
        this.par.areaName = options[2].label;
        this.par.areaId = options[2].value;
      } else {
        this.par.areaName = "";
        this.par.areaId = "";
      }
      this.par.areaName
        ? (this.par.allname =
          this.par.provinceName + this.par.cityName + this.par.areaName)
        : (this.par.allname = this.par.provinceName + this.par.cityName);
      Toast.hide();
    },
    handleChange({ options }) {
      this.getallvalue(options);
    },
    submitpar() {
      var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      var pattern2 = new RegExp("[A-Za-z]+");
      var pattern=new RegExp("^[0-9]*$");

      var myregs = /.*[\u4e00-\u9fa5]+.*$/;
      var pattern1 = new RegExp("^[A-Za-z]+$");
      if (!this.par.name) {
        Toast.failed("請輸入收貨人姓名");
        return;
      }
      if (this.par.code === "KR") {
        if (reg.test(this.par.name)) {
          Toast.failed("收貨人姓名不能为中文");
          return;
        }
      }
      if (this.par.code === "NZ") {
        if (reg.test(this.par.name)) {
          Toast.failed("收貨人姓名不能为中文");
          return;
        }
      }

      if (!this.par.mobile) {
        Toast.failed("請輸入收貨人電話");
        return;
      }
      if(this.par.code==='TW'){
        if (!(pattern.test(this.par.mobile))){
          Toast.failed("電話格式错误");
          return;
        }
      }
      if(this.par.code==='TW'){
        if (this.par.mobile.length!=10){
          Toast.failed("電話格式错误");
          return;
        }
      }

      if (this.par.code != "MY" && this.par.code != "SG") {
        if (!this.par.cityId) {
          Toast.failed("請選擇收貨人都市/區縣");
          return;
        }
      }

      if (
        !this.par.areaName &&
        this.par.code != "TW" &&
        this.par.code != "MY" &&
        this.par.code != "SG"
      ) {
        Toast.failed("請輸入收貨人地區");
        return;
      }
      if (!this.par.address) {
        Toast.failed("請輸入收貨人地址1");
        return;
      }

      if (this.par.code === "NZ") {
        if (reg.test(this.par.address)) {
          Toast.failed("地址1只能输入40个以内的英文字符");
          return;
        }
      }
      if (this.par.code === "NZ") {
        if (this.par.address.length > 40) {
          Toast.failed("地址1只能输入40个以内的英文字符");
          return;
        }
      }
      if (this.par.code === "NZ") {
        if (myregs.test(this.par.areaName) && this.par.areaName) {
          Toast.failed("市郊，只能填写英文+数字，不可填写纯数字");
          return;
        } else if (Number(this.par.areaName) + "" !== NaN + "") {
          Toast.failed("市郊，只能填写英文+数字，不可填写纯数字");
          return;
        } else if (!pattern2.test(this.par.areaName)) {
          Toast.failed("市郊，只能填写英文+数字，不可填写纯数字");
          return;
        }
      }
      if (!this.par.postalCode) {
        Toast.failed("請輸入收貨人郵遞區號");
        return;
      }
      const regsr = new RegExp("[\\u4E00-\\u9FFF]+","g");
      if (regsr.test(this.par.postalCode)) {
        Toast.failed("郵遞區號不能包含中文!");
        return;
      }
      if (this.par.code === "NZ") {
        if (Number(this.par.postalCode) + "" !== NaN + "") {
        } else {
          Toast.failed("邮编，只能填写纯数字");
          return;
        }
      }
      // if (!this.par.identity && this.par.code == "TW") {
      //   Toast.failed("請輸入收貨人證件號碼");
      //   return;
      // }
      if (!this.par.identity && this.par.code == "KR") {
        Toast.failed("請輸入通关码");
        return;
      }
      this.loading = true;
      var par = {};
      if (this.par.code != "TW") {
        par = this.par;
      } else {
        console.log(this.par);
        par = {
          countryName: this.par.countryName,
          name: this.par.name,
          countryId: this.par.countryId,
          mobile: this.par.mobile,
          allname: this.par.allname,
          address: this.par.address,
          addressStandby: this.par.addressStandby,
          postalCode: this.par.postalCode,
          identity: this.par.identity,
          code: this.par.code,
          isdedfault: this.par.isdedfault,
          isDefault: this.par.isDefault,
          idType: this.par.idType,
          idTname: this.par.idTname,
          provinceId: "",
          cityId:
            this.par.provinceId == this.par.cityId
              ? this.par.cityId
              : this.par.provinceId,
          cityName:
            this.par.provinceId == this.par.cityId
              ? this.par.cityName
              : this.par.provinceName,
          provinceName: "",
          id: this.par.id,
          areaName:
            this.par.provinceId == this.par.cityId
              ? this.par.areaName
              : this.par.cityName,
          areaId:
            this.par.provinceId == this.par.cityId
              ? this.par.areaId
              : this.par.cityId,
        };
      }
      this.http
        .APIASK(this.ports.addressupdate, "post", par)
        .then((res) => {
          this.loading = false;
          res ? this.$router.go(-1) : null;
        })
        .catch((err) => {
          if (this.par.code == "TW" && err.code == "E012") {
            const par = {
              name: "EZway提示",
            };
            Toast.hide();
            this.http
              .APIASK(this.ports.getMessageByName, "get", par)
              .then((res) => {
                this.mserg = err.msg;
                this.msgid = res.id;
                this.basicDialog.open = true;
              });
          } else {
            this.loading = false;
          }
        });
    },
    select(data) {
      console.log(this.data);
      Toast.loading("加载中...");
      if (data.index == 0) {
        const ieminde = this.data.options.findIndex((val) => {
          return val.value == data.value;
        });
        this.ieminde = ieminde;
        this.pushitmelist(data.value, ieminde);
      } else if (data.index == 1) {
        const iemi = this.data.options[this.ieminde].children.options.findIndex(
          (val) => {
            return val.value == data.value;
          }
        );
        this.getthree(data.value, iemi);
      }
    },
    getthree(id, iemi) {
      const par = {
        parentId: id,
        name: "",
      };
      this.http
        .APIASK(this.ports.districtsearch, "get", par)
        .then((res) => {
          if (res.length > 0) {
            const result = res.map(function (item) {
              return {
                label: item.name,
                value: item.id,
                children: { name: "", label: "", options: [] },
              };
            });
            const par = {
              name: "city",
              label: "请选择",
              options: result,
            };
            this.data.options[this.ieminde].children.options[iemi].children =
              par;
          } else {
            this.data.options[this.ieminde].children.options[iemi].children =
              {};
            this.getallvalue(this.$refs.tabpicker.getSelectedOptions());
            this.show = false;
          }
          Toast.hide();
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    handler(name, active) {
      this.par.isdedfault ? (this.par.isDefault = 1) : (this.par.isDefault = 0);
    },
    repert() {
      console.log(JSON.parse(localStorage.getItem("userinfoMobie")));
      Object.keys(this.par).map((key) => (this.par[key] = ""));
      this.par.countryName = JSON.parse(
        localStorage.getItem("userinfoMobie")
      ).disVo.name;
      this.par.countryId = JSON.parse(
        localStorage.getItem("userinfoMobie")
      ).disVo.id;
      this.par.code = JSON.parse(
        localStorage.getItem("userinfoMobie")
      ).disVo.code;
      this.par.isDefault = 0;
      this.par.isdedfault = false;
      this.par.idType = 0;
      this.par.idTname = "身份證";
      this.par.allname = "請選擇收貨人都市/區縣";
    },
  },
};
</script>

<style lang="less">
.addaddresContainer {
  .oebhe .md-dialog-content {
    width: 7rem;
  }

  .md-tab-bar {
    position: static;
    height: 1rem;
  }

  fieldset {
    padding: 0 0.2rem;
  }

  .md-field-item-title:before {
    content: "*";
    color: #e51c23;
    margin-right: 0.1rem;
    font-size: 0.5rem;
    margin-top: 0.1rem;
  }


  .md-cell-item-title:before {
    content: "*";
    color: #e51c23;
    margin-right: 0.1rem;
    font-size: 0.5rem;
    margin-top: 0.1rem;
  }
  .tanenr .md-field-item-title:before {
    content: "";
    color: #e51c23;
    margin-right: 0.1rem;
    font-size: 0.5rem;
    margin-top: 0.1rem;
  }

  .md-field-item.none .md-field-item-title:before {
    padding-right: 0.2rem;
    content: "";
  }

  .md-popup-title-bar {
    height: 2.5rem !important;
  }

  .md-tab-bar {
    margin-top: -1rem;
  }

  .md-cell-item-body {
    padding-top: 0;
    padding-bottom: 0;
  }

  .md-cell-item-title {
    width: 2rem;
    text-align: left;
    display: flex;
    align-items: center;
  }

  .md-radio-list {
    .md-cell-item-title {
      width: 4rem;
    }

    .md-cell-item-title:before {
      content: "";
    }
  }

  .md-cell-item-content {
    flex: 0;
  }

  .md-cell-item-right {
    width: 70%;
    justify-content: flex-start;

    img {
      width: 0.6rem;
      position: absolute;
      right: 0;
      top: 0.2rem;
    }
  }

  .md-input-item-brief {
    text-align: left;
    padding-bottom: 0.1rem;
    line-height: 0.4rem;
    color: #e51c23;
  }

  .md-field-item.is-solid .md-field-item-title {
    width: 2rem !important;
    display: flex;
    align-items: center;
  }

  .addresright .md-cell-item-title {
    width: 3rem;
  }

  .addresright .md-cell-item-right {
    width: 50%;
    justify-content: flex-end;
  }

  .heighter .md-field-item-content {
    .md-field-item-title {
      height: 1.5rem;
    }

    .md-input-item-input {
      height: 1.5rem;
    }
  }

  //.addresright
}
</style>
